const brokers = state => state.rating.brokers;
const broker = state => state.rating.broker;

export default {
  brokers,
  broker,
};
